import { CodedError } from '../../CodedError';
import { errorCodes } from '../../constants/errorCodes';

export class CcureInvalidFieldError extends CodedError {
  static get errorName() {
    return errorCodes.ccureInvalidFieldError.code;
  }

  constructor(message: string = errorCodes.ccureInvalidFieldError.message) {
    super(message);
    this.code = errorCodes.ccureInvalidFieldError.code;
    this.message = `${message} ${errorCodes.ccureInvalidFieldError.code}`;
    this.name = errorCodes.ccureInvalidFieldError.name;
  }
}
